<template>
    <div class="content">

        <SplitText :is-type="'h1'" class="t-h1 title anim-line-3">
            <span>
                Virtual assistant for hire
            </span>
        </SplitText>

        <div class="t-text block u-relative">

            <p class="text anim-2">
                <span>
                    Develop a laser-like focus on the big picture with the help of our bot-like virtual assistants.
                </span>
            </p>

            <ul class="list anim-1">
                <li class="item">
                    Research
                </li>
                <li class="item">
                    Email management
                </li>
                <li class="item">
                    Calendar management
                </li>
                <li class="item">
                    Meeting scheduling
                </li>
                <li class="item">
                    Social media
                </li>
                <li class="item">
                    Travel booking
                </li>
                <li class="item">
                    Remote office tasks
                </li>
            </ul>

        </div>
    </div>
</template>
<script>
import SplitText from '@/components/SplitText'

export default
{
    name: 'Assistant',

    components:
    {
        SplitText
    }
}
</script>
